import { ERROR_CODES } from '@/consts';

export default class AnotherClientUsedThatInfo extends Error {
  static code = ERROR_CODES.ANOTHER_CLIENT_USED_THAT_INFO;

  constructor(message) {
    super(message || 'Another Client Used That Info.');
    this.code = ERROR_CODES.ANOTHER_CLIENT_USED_THAT_INFO;
  }
}
